import { getStatusLabel, SLOT_STATUSES } from "../../../utils";

export default function EventSlotDetailCard({
  formData,
  errors,
  handleChange,
  toggleInstructor,
  instructors,
  eventTypeOptions,
}) {
  return (
    <div className="detail-form-grid">
      {/* COLONNE GAUCHE : Type, Nom, Animateurs, Statut */}
      <div className="detail-form-column">
        {/* Event Type */}
        <div className="form-group">
          <label htmlFor="event_type">
            Type d'événement <span className="required">*</span>
          </label>
          <select
            id="event_type"
            name="event_type"
            value={formData.event_type}
            onChange={handleChange}
            className={errors.event_type ? "error" : ""}
            required
          >
            <option value="">-- Sélectionner --</option>
            {eventTypeOptions.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
          {errors.event_type && (
            <span className="error-message">{errors.event_type}</span>
          )}
        </div>

        {/* Name */}
        <div className="form-group">
          <label htmlFor="name">Nom de l'événement</label>
          <input
            id="name"
            name="name"
            type="text"
            value={formData.name}
            onChange={handleChange}
            placeholder="Ex: Cours particulier débutant"
            className={errors.name ? "error" : ""}
          />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>

        {/* Instructors */}
        <div className="form-group">
          <label>Animateur</label>
          <div className="instructors-buttons">
            {instructors.map((t) => {
              const selected = formData.instructor_ids.includes(t.id);
              return (
                <button
                  key={t.id}
                  type="button"
                  className={`instructor-btn ${selected ? "selected" : ""}`}
                  onClick={() => toggleInstructor(t.id)}
                >
                  {t.first_name} {t.last_name}
                </button>
              );
            })}
          </div>
        </div>

        {/* Status */}
        <div className="form-group">
          <label>Statut</label>
          <div className="instructors-buttons">
            {Object.values(SLOT_STATUSES).map((status) => {
              const selected = formData.slot_status === status;
              return (
                <button
                  key={status}
                  id="slot_status"
                  name="slot_status"
                  value={status}
                  type="button"
                  className={`instructor-btn ${selected ? "selected" : ""}`}
                  onClick={handleChange}
                >
                  {getStatusLabel(status)}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* COLONNE DROITE : Date et horaires */}
      <div className="detail-form-column">
        {/* Date */}
        <div className="form-group">
          <label htmlFor="slot_date">
            Date <span className="required">*</span>
          </label>
          <input
            id="slot_date"
            name="slot_date"
            type="date"
            value={formData.slot_date}
            onChange={handleChange}
            className={errors.slot_date ? "error" : ""}
            required
          />
          {errors.slot_date && (
            <span className="error-message">{errors.slot_date}</span>
          )}
        </div>

        {/* All Day */}
        <div className="form-group form-group--checkbox">
          <label>
            <input
              type="checkbox"
              name="is_all_day"
              checked={formData.is_all_day}
              onChange={handleChange}
            />
            Événement toute la journée
          </label>
        </div>

        {/* Times */}
        {!formData.is_all_day && (
          <>
            <div className="form-group">
              <label htmlFor="start_time">
                Heure de début <span className="required">*</span>
              </label>
              <input
                id="start_time"
                name="start_time"
                type="time"
                value={formData.start_time}
                onChange={handleChange}
                className={errors.start_time ? "error" : ""}
                required
              />
              {errors.start_time && (
                <span className="error-message">{errors.start_time}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="end_time">
                Heure de fin <span className="required">*</span>
              </label>
              <input
                id="end_time"
                name="end_time"
                type="time"
                value={formData.end_time}
                onChange={handleChange}
                className={errors.end_time ? "error" : ""}
                required
              />
              {errors.end_time && (
                <span className="error-message">{errors.end_time}</span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
